import { Pipe, PipeTransform } from '@angular/core';
import { FileRecordDto } from '@careapp-group/ng-sdk';

/**
 * True if the given file record is a video file
 */
@Pipe({
    name: 'mediaIsVideo',
    pure: true,
    standalone: false
})
export class MediaIsVideoPipe implements PipeTransform {
  transform(value: FileRecordDto): boolean {
    if (!value || !value.mimeType) {
      return false;
    }
    return /^video\//.test(value.mimeType);
  }
}
